<template>
<div id='about-page' class='page'>
	<go-back/>	
	<div>
	
		<h6 class='heading'>{{$t('h-about')}}</h6>
	</div>
	
	<div class="page-content">
		<section>
			<div class='about-intro'>
			
				<p> {{$t('about-content-6')}}<br><br> {{$t('about-content-7')}}<br><br> {{$t('about-content-8')}}</p>
			</div>

			<ul class='list2'>
	
				<li><p>{{$t('name')}}</p><p class=''>{{$t('timambi')}}</p></li>
				<li><span>{{$t('title')}}</span><p>{{$t('about-content-9')}}</p></li>
				<li><span>{{$t('gender')}}</span><span>{{$t('male')}}</span></li>
				<li><span>{{$t('address')}}</span><span>{{$t('japan')}}</span></li>
				<li><span>{{$t('age')}}</span><span>24</span></li>
				<li><span>{{$t('level')}}</span><span>{{$t('noob')}}</span></li>
			</ul>
			
	
		</section>
		<section>
			<h3 class='bar-text'>{{$t('education')}}</h3>
			<ul>
				<li class="box-list">
					<span><i class="material-icons">article</i></span>
					<span><a href="https://www.uc-bcf.edu.ph/"><p>University of the Cordilleras</p></a></span>
					<span title='Bachelor of Science in Information Technology'>2018</span>
				</li>
				<li class="box-list">
					<span><i class="material-icons">article</i></span>
					<span><a href="https://www.facebook.com/Irisan-National-HIGH-School-1375998612721476/"><p>Irisan National High School</p></a></span>
					<span title='Secondary Education'>2012</span>
				</li>
				<li class="box-empty"> </li><br>
			
			</ul>
			<h3 class='bar-text'>{{$t('experience')}}</h3>
			<ul>
				<li class="box-list">
					<span><i class="material-icons">build</i></span>
					<span><p>マシンオペレーター</p></span>
					<span>6/18 ~</span>
				</li>
				<li class="box-list">
					<span><i class="material-icons">work</i></span>
					<span><p> Web Developer</p></span>
					<span>6/M</span>
				</li>
				<li class="box-empty"> </li><br>
			</ul>

			<h3 class='bar-text'>{{$t('certificate')}}</h3>
			<ul>
				<li class="box-list">
					<span><i class="material-icons">translate</i></span>
					<span><p>{{$t('jlpt')}}</p></span>
					<span><a href="https://academy.exceedlms.com/student/award/10325490"> N3</a></span>
				</li>
				<li class="box-list">
					<span><i class="material-icons">phonelink</i></span>
					<span><p>Mobile Sites Certification</p></span>
					<span><a href="https://academy.exceedlms.com/student/award/10325490">Google</a></span>
				</li>
				<li class="box-empty"> </li><br>
				
			</ul>
		
		
		</section>

		<section>
			<h3 class='bar-text'>{{$t('abilities')}}</h3>
			<ul class='list2'>
	
				<li><p>Innovative</p></li>
				<li><p>Creative Thinkiing</p></li>
				<li><p>Teamplayer</p><p>Support</p></li>
				<li><p>Teachable</p><p>Adaptive</p></li>

			</ul>
			<ul>
				<li class="box-list">
					<span><i class="material-icons">code</i></span>
					<span><p>Web Desinger / Programmer</p></span>
					<span>Posible</span>
				</li>
				<li class="box-list">
					<span><i class="material-icons">architecture</i></span>
					<span><p>Graphic Designer</p></span>
					<span>Posible</span>
				</li>
				<li class="box-list">
					<span><i class="material-icons">monochrome_photos</i></span>
					<span><p>Video Editor / Photographer</p></span>
					<span><a href="https://www.fb.com/timvma">Seasonal</a></span>
				</li>
				<li class="box-list">
					<span><i class="material-icons">device_unknown</i></span>
					<span><p>IT Help Desk </p></span>
					<span>Posible</span>
				</li>
			</ul>
			<p>{{$t('about-content-10')}}</p>
			
		
			<accordion :title="$t('hobbies')">
			
				<p>
					Mountain Climbing<br>
					Guitar<br>

				</p>
			
				
			</accordion>
			
		</section>
	</div>
		<div class="overlay">私のこと</div>

      
</div>
</template>

<script>
import Accordion from '@/components/Accordion'
import GoBack from '@/components/GoBack'
export default {

    components:{
		Accordion,
		GoBack
    }
}
</script>

<style lang="scss">

</style>